import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/typography.stylex';
import { typography } from '@tokens/typography.stylex';
import '@tokens/radius.stylex';
import { radius } from '@tokens/radius.stylex';
import '@tokens/shadows.stylex';
import { shadows } from '@tokens/shadows.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported from the prototype `.site-switch` (cloud-mode current-site control); the
// chevron now opens an inline dropdown to switch sites without leaving the page.
// Shared with `ui/Dot`'s own pulse — a site in real trouble (or genuinely healthy)
// must keep signalling that, not just paint a static colour once.
const pulse = "x1qebh90-B";
export const styles = {
  wrap: {
    kVAEAm: "x1n2onr6",
    $$css: true
  },
  btn: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1fwedmp",
    ks0D6T: "x1ncir08",
    kZKoxP: "x90ne7k",
    kg3NbH: "xy65nll",
    kaIpWk: "xxltkoq",
    kWkggS: "x16vpd03",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "x1xo1f5v",
    kkrTdU: "x1ypdohk",
    kmkexE: "x1k3q35m",
    kaVNsj: "x17y7a7r",
    $$css: true
  },
  dot: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kmuXW: "x2lah0s",
    kaIpWk: "xoy5co8",
    kWkggS: "x11bye3y",
    $$css: true
  },
  dotHealthy: {
    kWkggS: "x1k01o31",
    kGVxlE: "xl8337x",
    kKVMdj: "xvp9s6x x1aquc0h",
    k44tkh: "x18hd8ej",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  dotWarning: {
    kWkggS: "x7dh1j1",
    kGVxlE: "x1jjvob4",
    $$css: true
  },
  dotCritical: {
    kWkggS: "x4qlrbh",
    kGVxlE: "x1gz9b6j",
    kKVMdj: "xvp9s6x x1aquc0h",
    k44tkh: "x18hd8ej",
    ko0y90: "xa4qsjk",
    $$css: true
  },
  dotStale: {
    kWkggS: "x11bye3y",
    $$css: true
  },
  name: {
    k1xSpc: "x1lliihq",
    k7Eaqz: "xeuugli",
    k63SB2: "xomqrzn",
    kGuDYH: "x34ze3o",
    kLWn49: "xtqwzw6",
    kMwMTN: "x1oezkus",
    khDVqt: "xuxw1ft",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    $$css: true
  },
  chev: {
    kmuXW: "x2lah0s",
    kMwMTN: "xdxw5r1",
    kmkexE: "x1ojvxoa",
    $$css: true
  },
  chevOpen: {
    k3aq6I: "x19jd1h0",
    $$css: true
  },
  menu: {
    kVAEAm: "x10l6tqk xegw5ml",
    k87sOh: "xwwefxd x150vwk6",
    kCIrl2: "x3m8u43 x77kb69",
    kY2c9j: "xf5e64p",
    k7Eaqz: "x12rczxh",
    ks0D6T: "xvv7f4i",
    kskxy: "x7ab17h x18opn6o",
    kORKVm: "xryxfnj x37gjbb",
    kmVPX3: "xrqf348",
    kWkggS: "x13uruat",
    kMzoRj: "xmkeg23",
    ksu8eU: "x1y0btm7",
    kVAM5u: "xaj8nyx",
    kaIpWk: "xxltkoq",
    kGVxlE: "xkqgayn",
    $$css: true
  },
  item: {
    kI3sdo: "x1a2a7pz xq8uqhm",
    kInvED: "x2ssjo2",
    k1xSpc: "x78zum5",
    kGNEyG: "x6s0dn4",
    kOIVth: "x1mnnc3i",
    kzqmXN: "xh8yej3",
    kmVPX3: "x1160tuk",
    kaIpWk: "x1d0dq8e",
    kWkggS: "xjbqb8w",
    kkrTdU: "x1ypdohk",
    kMv6JI: "xdv2sak",
    kGuDYH: "x2pyw9z",
    k63SB2: "xssbmp7",
    kMwMTN: "xdxw5r1",
    k9WMMc: "xdpxx8g",
    kmkexE: "x1k3q35m",
    kGzVvX: "x5lqt2c",
    kDPRdz: "x1tqbdv0",
    $$css: true
  },
  itemOn: {
    kMwMTN: "x1oezkus",
    $$css: true
  },
  itemDot: {
    kzqmXN: "xci0xqf",
    kZKoxP: "x1hagigm",
    kmuXW: "x2lah0s",
    kaIpWk: "xoy5co8",
    kWkggS: "x1c1bete",
    $$css: true
  },
  itemDotOn: {
    kWkggS: "xlvhwkj",
    kGVxlE: "xczid80",
    $$css: true
  },
  itemName: {
    kUk6DE: "x98rzlu",
    k7Eaqz: "xeuugli",
    khDVqt: "xuxw1ft",
    kVQacm: "xb3r6kr",
    kg5iWk: "xlyipyv",
    $$css: true
  },
  itemStatus: {
    kMwMTN: "xdxw5r1",
    k63SB2: "xssbmp7",
    $$css: true
  },
  check: {
    kmuXW: "x2lah0s",
    kMwMTN: "x1459q0w",
    $$css: true
  }
};